export class Sticky {
  constructor(element, options = { offset: 0 }) {
    this.element = element
    this.offset = options.offset

    const elementItems = element.getElementsByClassName('js-stickyItem')
    if (!elementItems.length) return

    this.elementItem = elementItems[0]
    this.elementItem.style.width = `${this.elementItem.clientWidth}px`

    this.setStatus()
    window.addEventListener('scroll', () => {
      this.setStatus()
    })
  }

  setStatus() {
    const breakPointStartSticky = this.element.offsetTop - this.offset
    const breakPointEndSticky =
      this.element.offsetTop +
      this.element.clientHeight -
      this.offset -
      this.elementItem.clientHeight
    if (window.scrollY > breakPointStartSticky) {
      if (window.scrollY < breakPointEndSticky) {
        this.setSticky()
      } else {
        this.setItemBottom()
      }
    } else {
      this.resetSticky()
    }
  }

  setItemBottom() {
    this.element.style.paddingTop = `${this.heightSum}px`
    this.elementItem.style.position = 'absolute'
    this.elementItem.style.top = null
    this.elementItem.style.bottom = 0
    this.elementItem.style.height = null
  }

  setSticky() {
    const height = this.elementItem.clientHeight
    this.element.style.paddingTop = `${height}px`
    this.elementItem.style.position = 'fixed'
    this.elementItem.style.top = `${this.offset}px`
    this.elementItem.style.bottom = null
    this.elementItem.style.height = `${window.innerHeight - this.offset}px`
  }

  resetSticky() {
    this.element.style.paddingTop = null
    this.elementItem.style.position = null
    this.elementItem.style.top = null
    this.elementItem.style.bottom = null
    this.elementItem.style.height = null
  }
}
